module.exports = __webpack_public_path__ + "img/brand-04.4b6c9020.png";